import React, {useEffect, useRef, useState} from 'react';
import * as BookingsChannelsStyle from "./bookingsChannels.module.scss"
import {StaticImage} from "gatsby-plugin-image";
import Carousel, {CarouselItem} from "../../common/carousel/carousel";
import {useIsInViewport} from "../../../utils/isElementInViewPort";

function BookingsChannels() {
  const [activeBookingChannel, setActiveBookingChannel] = useState('instagram')
  const [animate, setAnimate] = useState(false);
  const sectionRef = useRef(null);
  const isSectionInViewport = useIsInViewport(sectionRef);

  useEffect(() => {
    if (isSectionInViewport) {
      setAnimate(true);
    }
  }, [isSectionInViewport]);

  useEffect(() => {
    const sectionTimeout = setTimeout(() => {
      const sections = ['instagram', 'share-link', 'iframe', 'trafft-booking-page', 'qr-booking', 'google-reserve'];
      const currentIndex = sections.indexOf(activeBookingChannel);
      const nextIndex = (currentIndex + 1) % sections.length;
      const nextSection = sections[nextIndex];
      if (animate) {
        setActiveBookingChannel(nextSection);
      }
    }, 3000);

    return () => clearTimeout(sectionTimeout);
  }, [activeBookingChannel, animate]);

  return (
    <div className={BookingsChannelsStyle.bookingsChannelWrapper} onMouseOver={() => setAnimate(false)} onMouseLeave={() => setAnimate(true)} ref={sectionRef}>
      <h2 className={BookingsChannelsStyle.bookingsChannelWrapper__title}>All your booking channels</h2>
      <div className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel}>
        <div className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__mobile}>
          <Carousel>
            <CarouselItem>
              <div className={BookingsChannelsStyle.bookingsChannelWrapper__responsiveCard}>
                <div className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image}`}>
                  <StaticImage src='../../../images/homepage/bookingChannels/instagram - V2.webp' alt='Instagram'/>
                </div>
                <div className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card}>
                  <StaticImage src='../../../images/homepage/bookingChannels/icons/inst.svg' alt='' width={48}
                               className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__icon}/>
                  <p
                    className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardTitle}>Instagram</p>
                  <p
                    className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardDescription}>
                    Share your available hours and time slots in your <span>Instagram story</span> for instant access
                    and bookings or copy the booking form link and add it to your <span>Instagram bio.</span>
                  </p>
                </div>
              </div>
            </CarouselItem>
            <CarouselItem>
              <div className={BookingsChannelsStyle.bookingsChannelWrapper__responsiveCard}>
                <div className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image}`}>
                  <StaticImage src='../../../images/homepage/bookingChannels/Share booking link on - V2.webp'
                               alt='Share booking link on'/>
                </div>
                <div className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card}>
                  <StaticImage src='../../../images/homepage/bookingChannels/icons/share.svg' alt=''
                               className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__icon}
                               width={48}/>
                  <div
                    className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardTitle}>
                    Share booking link on
                    <StaticImage src='../../../images/homepage/bookingChannels/icons/social-media.svg'
                                 alt='Social media icons' width={93}/>
                  </div>
                  <p
                    className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardDescription}>
                    Specify details for your available time slots, get a booking link from Trafft and share it on <span>Facebook, Twitter and LinkedIn</span> or
                    send it directly to your customers via <span>email.</span>
                  </p>
                </div>
              </div>
            </CarouselItem>
            <CarouselItem>
              <div className={BookingsChannelsStyle.bookingsChannelWrapper__responsiveCard}>
                <div className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image}`}>
                  <StaticImage src='../../../images/homepage/bookingChannels/Iframe on your booking website - V2.webp'
                               alt='Iframe on your booking website'/>
                </div>
                <div className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card}>
                  <StaticImage src='../../../images/homepage/bookingChannels/icons/embed.svg' alt='' width={48}
                               className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__icon}/>
                  <p
                    className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardTitle}>Embed</p>
                  <p
                    className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardDescription}>
                    If you have a website, <span>embed a booking form</span> on any page and allow customers to easily
                    schedule appointments during their visit.
                  </p>
                </div>
              </div>
            </CarouselItem>
            <CarouselItem>
              <div className={BookingsChannelsStyle.bookingsChannelWrapper__responsiveCard}>
                <div className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image}`}>
                  <StaticImage src='../../../images/homepage/bookingChannels/Booking page by Trafft - V2.webp'
                               alt='Iframe on your booking website'/>
                </div>
                <div className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card}>
                  <StaticImage src='../../../images/homepage/bookingChannels/icons/trafft.svg' alt='' width={48}
                               className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__icon}/>
                  <p
                    className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardTitle}>Booking
                    page by Trafft</p>
                  <p
                    className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardDescription}>
                    No website? No problem! Trafft provides
                    a <span>beautiful and fully functional booking website</span> you can easily set up, share with your
                    clients, and start enjoying the benefits of online booking in no time.
                  </p>
                </div>
              </div>
            </CarouselItem>
            <CarouselItem>
              <div className={BookingsChannelsStyle.bookingsChannelWrapper__responsiveCard}>
                <div className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image}`}>
                  <StaticImage src='../../../images/homepage/bookingChannels/_Book with QR code - V2.webp'
                               alt='Book with QR code'/>
                </div>
                <div className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card}>
                  <StaticImage src='../../../images/homepage/bookingChannels/icons/QR.svg' alt='' width={48}
                               className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__icon}/>
                  <p
                    className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardTitle}>Book
                    with QR code </p>
                  <p
                    className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardDescription}>
                    Add available time slots, specify appointment details, get a QR code form Trafft and share it with
                    your clients. A simple scan will <span>instantly book an appointment.</span>
                  </p>
                </div>
              </div>
            </CarouselItem>
            <CarouselItem>
              <div className={BookingsChannelsStyle.bookingsChannelWrapper__responsiveCard}>
                <div className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image}`}>
                  <StaticImage src='../../../images/homepage/bookingChannels/Reserve with Google - V2.webp'
                               alt='Reserve with Google'/>
                </div>
                <div className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card}>
                  <StaticImage src='../../../images/homepage/bookingChannels/icons/google.svg' alt='' width={48}
                               className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__icon}/>
                  <p
                    className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardTitle}>Reserve
                    with Google</p>
                  <p
                    className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardDescription}>
                    Reserve with Google helps you reach millions of potential customers by showcasing your services and
                    availability directly on <span>Google Search and Maps.</span></p>
                </div>
              </div>
            </CarouselItem>
          </Carousel>
        </div>
        <div className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__desktop}>
            <div
              className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image} ${activeBookingChannel === 'instagram' ? BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image_show : ''}`}>
              <StaticImage src='../../../images/homepage/bookingChannels/instagram - V2.webp' alt='Instagram'/>
            </div>
            <div
              className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image} ${activeBookingChannel === 'share-link' ? BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image_show : ''}`}>
              <StaticImage src='../../../images/homepage/bookingChannels/Share booking link on - V2.webp'
                           alt='Share booking link on'/>
            </div>
            <div
              className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image} ${activeBookingChannel === 'iframe' ? BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image_show : ''}`}>
              <StaticImage src='../../../images/homepage/bookingChannels/Iframe on your booking website - V2.webp'
                           alt='Iframe on your booking website'/>
            </div>
            <div
              className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image} ${activeBookingChannel === 'trafft-booking-page' ? BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image_show : ''}`}>
              <StaticImage src='../../../images/homepage/bookingChannels/Booking page by Trafft - V2.webp'
                           alt='Booking page by Trafft'/>
            </div>
            <div
              className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image} ${activeBookingChannel === 'qr-booking' ? BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image_show : ''}`}>
              <StaticImage src='../../../images/homepage/bookingChannels/_Book with QR code - V2.webp'
                           alt='Book with QR code'/>
            </div>
            <div
              className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image} ${activeBookingChannel === 'google-reserve' ? BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__image_show : ''}`}>
              <StaticImage src='../../../images/homepage/bookingChannels/Reserve with Google - V2.webp'
                           alt='Reserve with Google'/>
            </div>
            <div className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards}>
              <div className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card} 
          ${activeBookingChannel === 'instagram' ? BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card_active : ''}`}
                   onClick={() => setActiveBookingChannel('instagram')}>
                <StaticImage src='../../../images/homepage/bookingChannels/icons/inst.svg' alt='' width={48}
                             className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__icon}/>
                <p
                  className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardTitle}>Instagram</p>
                <p
                  className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardDescription}>
                  Share your available hours and time slots in your <span>Instagram story</span> for instant access
                  and bookings or copy the booking form link and add it to your <span>Instagram bio.</span>
                </p>
              </div>
              <div className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card} 
          ${activeBookingChannel === 'share-link' ? BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card_active : ''}`}
                   onClick={() => setActiveBookingChannel('share-link')}>
                <StaticImage src='../../../images/homepage/bookingChannels/icons/share.svg' alt=''
                             className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__icon}
                             width={48}/>
                <div
                  className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardTitle}>
                  Share booking link on
                  <StaticImage src='../../../images/homepage/bookingChannels/icons/social-media.svg'
                               alt='Social media icons' width={93}/>
                </div>
                <p
                  className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardDescription}>
                  Specify details for your available time slots, get a booking link from Trafft and share it on <span>Facebook, Twitter and LinkedIn</span> or
                  send it directly to your customers via <span>email.</span>
                </p>
              </div>
              <div className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card} 
          ${activeBookingChannel === 'iframe' ? BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card_active : ''}`}
                   onClick={() => setActiveBookingChannel('iframe')}>
                <StaticImage src='../../../images/homepage/bookingChannels/icons/embed.svg' alt='' width={48}
                             className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__icon}/>
                <p
                  className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardTitle}>Embed</p>
                <p
                  className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardDescription}>
                  If you have a website, <span>embed a booking form</span> on any page and allow customers to easily
                  schedule appointments during their visit.
                </p>
              </div>
              <div className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card} 
          ${activeBookingChannel === 'trafft-booking-page' ? BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card_active : ''}`}
                   onClick={() => setActiveBookingChannel('trafft-booking-page')}>
                <StaticImage src='../../../images/homepage/bookingChannels/icons/trafft.svg' alt='' width={48}
                             className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__icon}/>
                <p
                  className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardTitle}>Booking
                  page by Trafft</p>
                <p
                  className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardDescription}>
                  No website? No problem! Trafft provides
                  a <span>beautiful and fully functional booking website</span> you can easily set up, share with your
                  clients, and start enjoying the benefits of online booking in no time.
                </p>
              </div>
              <div className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card} 
          ${activeBookingChannel === 'qr-booking' ? BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card_active : ''}`}
                   onClick={() => setActiveBookingChannel('qr-booking')}>
                <StaticImage src='../../../images/homepage/bookingChannels/icons/QR.svg' alt='' width={48}
                             className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__icon}/>
                <p
                  className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardTitle}>Book
                  with QR code </p>
                <p
                  className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardDescription}>
                  Add available time slots, specify appointment details, get a QR code form Trafft and share it with
                  your clients. A simple scan will <span>instantly book an appointment.</span>
                </p>
              </div>
              <div className={`${BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card} 
          ${activeBookingChannel === 'google-reserve' ? BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card_active : ''}`}
                   onClick={() => setActiveBookingChannel('google-reserve')}>
                <StaticImage src='../../../images/homepage/bookingChannels/icons/google.svg' alt='' width={48}
                             className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__icon}/>
                <p
                  className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardTitle}>Reserve
                  with Google</p>
                <p
                  className={BookingsChannelsStyle.bookingsChannelWrapper__bookingsChannel__cards__card__cardDescription}>
                  Reserve with Google helps you reach millions of potential customers by showcasing your services and
                  availability directly on <span>Google Search and Maps.</span></p>
              </div>
            </div>
        </div>
        </div>
      </div>
      );
      }

      export default BookingsChannels;